import React, { useEffect, useState, useMemo } from 'react'
import Topbar from '../../Components/Topbar'
import LeftbarUser from '../../Components/LeftbarUser'
import BottomNavUser from '../../Components/BottomNavUser'
import { getFirestore, collection, getDocs } from 'firebase/firestore'
import { app } from '../../firebase'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faTiktok, faYoutube, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { Link } from 'react-router-dom'
import defProfile from '../../Images/def.png'

function UserInfluencers() {
  const db = getFirestore(app)
  const [influencers, setInfluencers] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [platform, setPlatform] = useState("all")
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchInfluencers = async () => {
      setLoading(true)
      const querySnap = await getDocs(collection(db, "users"))
      const data = []
      querySnap.forEach(doc => {
        const item = doc.data()
        // Only include verified influencers
        if (item.userType === "An Influencer" && item.accountIsVerified) {
          data.push({ id: doc.id, ...item })
        }
      })
      setInfluencers(data)
      setLoading(false)
    }
    fetchInfluencers()
  }, [db])

    useEffect(() => {
      document.title = "Zindua App | Dashboard";
  
      // Meta description
      let desc = document.querySelector("meta[name='description']");
      if (!desc) {
        desc = document.createElement("meta");
        desc.setAttribute("name", "description");
        document.head.appendChild(desc);
      }
      desc.setAttribute("content", "Zindua App dashboard");
  
      // Open Graph tags
      const ogTags = [
        { property: "og:title", content: "Zindua App | Dashboard" },
        { property: "og:description", content: "Zindua App Dashboard" },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://zindua.app/dashboard" },
        { property: "og:image", content: "https://zindua.app/logo192.png" },
      ];
  
      ogTags.forEach(({ property, content }) => {
        let tag = document.querySelector(`meta[property='${property}']`);
        if (!tag) {
          tag = document.createElement("meta");
          tag.setAttribute("property", property);
          document.head.appendChild(tag);
        }
        tag.setAttribute("content", content);
      });
  
      // JSON-LD structured data
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Zindua App Influencer Dashboard",
        "url": "https://zindua.app/dashboard",
        "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
        "inLanguage": "en",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://zindua.app/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Dashboard",
              "item": "https://zindua.app/dashboard"
            }
          ]
        }
      });
      document.head.appendChild(script);
  
      return () => {
        document.head.removeChild(script);
      };
    }, []);


  // this is the code
  const filtered = useMemo(() => {
    return influencers.filter(u => {
      const matchName = u.userName?.toLowerCase().includes(searchTerm.toLowerCase())
      const matchPlatform =
        platform === "all" ||
        (u.socials && (u.socials[platform] === true || u.socials[platform] === "selected"))
      return matchName && matchPlatform
    })
  }, [influencers, searchTerm, platform])

  return (
    <div className="mainDashboard">
      <div className="desktopOnly">
        <LeftbarUser />
      </div>

      <div className="mainContent">
        <Topbar />

        <div className="filterBar">
          <select
            className="platformSelect"
            onChange={e => setPlatform(e.target.value)}
            value={platform}
          >
            <option value="all">All platforms</option>
            <option value="instagram">Instagram</option>
            <option value="twitter">Twitter</option>
            <option value="tiktok">TikTok</option>
            <option value="youtube">YouTube</option>
          </select>

          <input
            type="text"
            placeholder="Search influencer"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="searchInfluencerInput"
          />
        </div>

        {loading ? (
          <p>Loading influencers...</p>
        ) : (
          <section className="influencerGrid">
            {filtered.map(user => {
              const prices = []
              if (user.servicePricing) {
                ['instagram', 'tiktok', 'youtube', 'twitter'].forEach(p => {
                  const platformData = user.servicePricing[p]
                  if (platformData) {
                    const direct = platformData.directBrandContent
                    if (direct) {
                      if (direct.post) prices.push(direct.post)
                      if (direct.story) prices.push(direct.story)
                    }
                    const cgc = platformData.creatorGeneratedContent
                    if (cgc?.price) prices.push(cgc.price)
                  }
                })
              }

              const lowestPrice = prices.length ? Math.min(...prices) : null
              const influencerLink = `/${user.theUsername}`

              return (
                <Link key={user.id} to={influencerLink} className="influencerCard">
                  <h6>{user.userName}</h6>
                  <p>{user.countryName}</p>

                  <div className="profileImgWrap">
                    <img src={user.profileImage || defProfile} alt="profile" />
                  </div>

                  {lowestPrice && <p>From KES {Number(lowestPrice).toLocaleString()}</p>}

                  <div className="socialPlatforms">
                    {user.socials && Object.keys(user.socials).map(p => {
                      if (user.socials[p] === true || user.socials[p] === "selected") {
                        let icon
                        if (p === 'instagram') icon = faInstagram
                        else if (p === 'tiktok') icon = faTiktok
                        else if (p === 'youtube') icon = faYoutube
                        else if (p === 'twitter') icon = faTwitter
                        else return null
                        return <FontAwesomeIcon key={p} icon={icon} className="socialIcon" />
                      }
                      return null
                    })}
                  </div>
                </Link>
              )
            })}
          </section>
        )}
      </div>

      <div className="mobileOnly">
        <BottomNavUser />
      </div>
    </div>
  )
}

export default UserInfluencers